import {
	ADD_AVATAR_FAIL,
	ADD_AVATAR_START,
	ADD_AVATAR_SUCCESS,
	GENERATE_EVENT_FAIL,
	GENERATE_EVENT_START, GENERATE_EVENT_SUCCESS,
	GET_EVENTS_FAIL,
	GET_EVENTS_START,
	GET_EVENTS_SUCCESS,
	SET_CLOSE_SNACK,
	SET_LANG,
	SET_OPEN_SNACK,
	SET_ROLE,
	SET_TAB,
	SET_THEME
} from "../reducers/actions/ActionTypes";
import {responsiveFontSizes} from '@mui/material/styles';
import axios from "axios";
import {
	ADD_PROFILE_IMAGE_URL, GENERATE_EVENT_URL, GET_EVENTS_BETWEEN_URL
} from "./utils/ApiUrls";
import {getAccountInfo} from "../utils/GenericUtils";
import {getFileData} from "./utils/ApiData";
import {getConfig} from "./utils/ConfigUtils";
import {getErrorMessage} from "../reducers/utils/ReducerUtils";
import moment from "moment";
import {authLogout} from "./AuthServices";
import {createAtlantisTheme} from "../styles/theme/AtlantisTheme";


export function setThemeType(type, theme, dispatch, fontSize = 16, primary, secondary) {
	let newTheme = createAtlantisTheme({type, fontSize, primary, secondary});
	responsiveFontSizes(newTheme);
	dispatch({type: SET_THEME, payload: newTheme})
}

export function setTab(tab, dispatch) {
	dispatch({type: SET_TAB, payload: tab});
}

export function setRole(newRole, dispatch) {
	dispatch({type: SET_ROLE, payload: newRole});
}

export function setLang(lang, dispatch) {
	dispatch({type: SET_LANG, payload: lang})
}

export function setOpenSnackbar(severity, message, dispatch) {
	dispatch({type: SET_OPEN_SNACK, severity: severity, message: message});
}

export function setCloseSnackbar(dispatch) {
	dispatch({type: SET_CLOSE_SNACK});
}

export function setUserAvatar(data, dispatch) {
	dispatch({type: ADD_AVATAR_START});
	axios
		.post(ADD_PROFILE_IMAGE_URL + getAccountInfo()?.username, getFileData(data["userPicture"], "avatar"), getConfig())
		.then(() => dispatch({type: ADD_AVATAR_SUCCESS}))
		.catch((error) => dispatch({type: ADD_AVATAR_FAIL, error: getErrorMessage(error)}))
}

export function getEventiBetween(date1, date2, dispatch) {
	dispatch({type: GET_EVENTS_START});
	axios
		.get(GET_EVENTS_BETWEEN_URL + moment(date1).format("DD-MM-YYYY") + "/" + moment(date2).format("DD-MM-YYYY"), getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GET_EVENTS_SUCCESS, payload: response.data})
			}
		})
		.catch((error) => dispatch({type: GET_EVENTS_FAIL, error: getErrorMessage(error)}))
}

export function generateEvent(event, dispatch) {
	dispatch({type: GENERATE_EVENT_START})
	axios
		.post(GENERATE_EVENT_URL, event, getConfig())
		.then((response) => {
			if (response.status === 226) {
				authLogout();
			} else {
				dispatch({type: GENERATE_EVENT_SUCCESS});
			}
		})
		.catch((error) => dispatch({type: GENERATE_EVENT_FAIL, error: getErrorMessage(error)}))
}
